import { LocaleOption } from './types';

export const LOCALES: LocaleOption[] = [
  { label: 'English', value: 'en' },
  { label: 'French', value: 'fr' },
  { label: 'Dutch', value: 'nl' },
];

export const DEFAULT_FORM_DATA = {
  colocFirstName: '',
  colocLastName: '',
  colocEmail: '',
  colocMobileCountryCode: '32', // Default to Belgium
  colocMobileNumber: '',
  colocLocale: 'en', // Default to English
  colocId: '',
  colocBirthday: null,
  colocBirthplace: '',
  securityDepositAmount: '',
  securityDepositAmountPaid: '',
};
